/**
 * @generated SignedSource<<2c8649005d8387983b066a1ddcaa5d5e>>
 * @relayHash 9542d881c4dd4d5a0f6759d25cb4fb2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 20964149de7cc66b86720e3feb257219e152ebe8d64d0f12c007042fb096b755

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ThemeSetterQuery$variables = {
  cloudId: string;
  projectIdOrKey: string;
};
export type ThemeSetterQuery$data = {
  readonly jira: {
    readonly mediaClientId: string | null | undefined;
    readonly mediaExternalEndpointUrl: string | null | undefined;
  };
  readonly jira_projectByIdOrKey: {
    readonly background: {
      readonly " $fragmentSpreads": FragmentRefs<"ThemeSetterBackground">;
    } | null | undefined;
    readonly projectId: string | null | undefined;
  } | null | undefined;
};
export type ThemeSetterQuery = {
  response: ThemeSetterQuery$data;
  variables: ThemeSetterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIdOrKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaClientId"
    },
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaExternalEndpointUrl"
    }
  ]
},
v4 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThemeSetterQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v3/*: any*/),
        "action": "THROW",
        "path": "jira"
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "background",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ThemeSetterBackground"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThemeSetterQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "background",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraActiveBackgroundDetailsResult"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "colorValue"
                  }
                ],
                "type": "JiraColorBackground"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                  }
                ],
                "type": "JiraGradientBackground"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "mediaApiFileId"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "durationInSeconds",
                            "value": 900
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "mediaReadToken",
                        "storageKey": "mediaReadToken(durationInSeconds:900)"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "sourceType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "sourceIdentifier"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "altText"
                      }
                    ]
                  }
                ],
                "type": "JiraMediaBackground"
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "20964149de7cc66b86720e3feb257219e152ebe8d64d0f12c007042fb096b755",
    "metadata": {},
    "name": "ThemeSetterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ee90b6b8dd5117bc04701d62de0795a3";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
